import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

gsap.config({
  force3D: false,
  nullTargetWarn: false,
});

gsap.defaults({
  ease: "power1.out",
});

export const preAnimate = () => {
  setDefaults();
  const master = gsap.timeline();
  master.add(
    showElements([
      ".a2b .challenge .hero__content",
      ".a2b .challenge .animation-btn",
    ])
  );
  return master;
};

function setDefaults() {
  gsap.set(".a2b-truck", { x: 1280 });
  gsap.set(".a2b-stop-3", { stopOpacity: 1 });
  gsap.set(".a2b-stop-4", { stopOpacity: 1 });
  gsap.set(".a2b-box", { y: -250, autoAlpha: 0 });
  gsap.set(".a2b-boxes", { autoAlpha: 0 });
  gsap.set(".a2b-road", { x: 1280 });
  gsap.set(".a2b-phone-wrapper", { x: 460 });
  gsap.set(".a2b-robot-mask", { y: 230 });
  gsap.set(".a2b-robot", { y: 230 });
  gsap.set(".a2b-scan", { autoAlpha: 0, transformOrigin: "left 50%" });
  gsap.set(".a2b-phone-btn", { transformOrigin: "50% 50%" });
  gsap.set(".a2b-loaded", { autoAlpha: 0 });
  gsap.set(".a2b-percentage-100", { autoAlpha: 0 });
  gsap.set(".a2b-phone-mask", { y: 505 });
  gsap.set(".a2b-phone", { y: 505 });
  gsap.set(".a2b-robot-portal-top", {
    scaleX: 0,
    scaleY: 0,
    transformOrigin: "50% 4px",
  });
  gsap.set(".a2b-robot-portal-bottom", {
    scaleX: 0,
    scaleY: 0,
    transformOrigin: "50% -4px",
  });
  gsap.set(".a2b-phone-portal-top", {
    scaleX: 0,
    scaleY: 0,
    transformOrigin: "50% 4px",
  });
  gsap.set(".a2b-phone-portal-bottom", {
    scaleX: 0,
    scaleY: 0,
    transformOrigin: "50% -4px",
  });
}

export const afterAnimate = () => {
  gsap.set(".a2b-stop-3", { stopOpacity: 0 });
  gsap.set(".a2b-stop-4", { stopOpacity: 0 });
  gsap.set(".a2b-truck", { autoAlpha: 0 });
  gsap.set(".a2b-road", { autoAlpha: 0 });
  gsap.set(".a2b-phone-wrapper", { x: 0 });
  gsap.set(".a2b-phone", { y: 0 });
  gsap.set(".a2b-boxes", { autoAlpha: 0 });
  gsap.set(".a2b-robot", { autoAlpha: 0 });
  gsap.set(".a2b-scan", { autoAlpha: 0 });
  gsap.set(".a2b-phone-btn", { autoAlpha: 0 });
  gsap.set(".a2b-loaded", { autoAlpha: 0 });
  gsap.set(".a2b-robot-mask", { autoAlpha: 0 });
  gsap.set(".a2b-phone-mask", { autoAlpha: 0 });
  gsap.set(".a2b-robot-portal-top", { autoAlpha: 0 });
  gsap.set(".a2b-robot-portal-bottom", { autoAlpha: 0 });
  gsap.set(".a2b-phone-portal-top", { autoAlpha: 0 });
  gsap.set(".a2b-phone-portal-bottom", { autoAlpha: 0 });
  gsap.set(".a2b .challenge__content", {
    autoAlpha: 1,
    visibility: "visible",
    y: 0,
  });
};

const master = gsap.timeline({
  paused: true,
});
export const animation = (setIsFinished) => {
  master
    .add(hideContent(".a2b .challenge .hero__content"))
    .add(moveTo(".a2b-truck", 1.5), "<")
    .add(moveTo(".a2b-road", 1.5, 100), "<")
    .add(showElements(".a2b-boxes", 0.01))
    .add(portalAnimation(".a2b-robot-portal-top", 0.3, 2.4, 1))
    .add(portalAnimation(".a2b-robot-portal-bottom", 0.3, 2.4, 1), "<")
    .add(moveTo(".a2b-robot", 0.5))
    .add(portalAnimation(".a2b-robot-portal-top", 0.2, 1, 1))
    .add(portalAnimation(".a2b-robot-portal-bottom", 0.2, 1, 1), "<")
    .add(showElements(".a2b-scan", 0.1))
    .add(setGradient(".a2b-stop-3", 0, 0.1), "<")
    .add(setGradient(".a2b-stop-4", 0, 0.1), "<")
    .add(scanAnimation(".a2b-scan"), "+=0.2")
    .add(gradientAnimation(".a2b-stop-2", "2%"), "<")
    .add(gradientAnimation(".a2b-stop-3", "4%"), "<")
    .add(gradientAnimation(".a2b-stop-4", "24%"), "<")
    .add(gradientAnimation(".a2b-stop-5", "26%"), "<")
    .add(hideItem(".a2b-scan", 0.1), "+=0.2")
    .add(setGradient(".a2b-stop-3", 1, 0.1), "<")
    .add(setGradient(".a2b-stop-4", 1, 0.1), "<")
    .add(showElements(".a2b-loaded", 0.1), "<")
    .add(portalAnimation(".a2b-phone-portal-top"))
    .add(portalAnimation(".a2b-phone-portal-bottom"), "<")
    .add(moveTo(".a2b-phone", 0.8))
    .add(portalAnimation(".a2b-phone-portal-top", 0.3, 0, 0))
    .add(portalAnimation(".a2b-phone-portal-bottom", 0.3, 0, 0), "<")
    .add(btnAnimation(".a2b-phone-btn"))
    .add(showBoxes(".a2b-box"))
    .add(moveBoxes(".a2b-box"), "<")
    .add(jumpAnimation(".a2b-trailer"), "<0.8")
    .add(jumpAnimation(".a2b-trailer"), "<0.5")
    .add(jumpAnimation(".a2b-trailer", "<0.5"))
    .add(hideItem(".a2b-boxes", 0.01))
    .add(hideItem(".a2b-percentage-70", 0.1))
    .add(showElements(".a2b-percentage-100", 0.1), "<")
    .add(portalAnimation(".a2b-robot-portal-top", 0.5, 2.4, 1))
    .add(portalAnimation(".a2b-robot-portal-bottom", 0.5, 2.4, 1), "<")
    .add(moveTo(".a2b-robot", 0.5, 0, 230))
    .add(portalAnimation(".a2b-robot-portal-top", 0.5, 0, 0))
    .add(portalAnimation(".a2b-robot-portal-bottom", 0.5, 0, 0), "<")
    .add(moveTo(".a2b-truck", 1.5, -1000), "<")
    .add(moveTo(".a2b-road", 1.5, -800), "<")
    .add(hideItem(".a2b-truck", 1.5), "<")
    .add(hideItem(".a2b-road", 1.5), "<")
    .add(moveTo(".a2b-phone-wrapper", 1), "<")
    .add(showContent(".a2b .challenge .challenge__content"))
    .to(".a2b .challenge .animation-btn", {
      autoAlpha: 0,
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        setIsFinished(true);
      },
    });

  return master;
};

function moveTo(selector, duration = 0.5, x = 0, y = 0) {
  const tl = gsap.timeline();
  tl.to(selector, { x, y, duration });
  return tl;
}

function scanAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { scaleX: -1, yoyo: true, repeat: 1, duration: 1.3 });
  return tl;
}

function btnAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { scale: 0.7, yoyo: true, repeat: 1, duration: 0.1 }).to(
    selector,
    { autoAlpha: 0, duration: 0.1 },
    "+=0.2"
  );
  return tl;
}

function hideItem(selector, duration = 0.5) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 0, duration });
  return tl;
}

function showElements(selectors, duration = 0) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 1, opacity: 1, duration });
  return tl;
}
function showBoxes(selector, duration = 0.1) {
  const tl = gsap.timeline();
  tl.to(selector, {
    autoAlpha: 1,
    duration,
    stagger: 0.6,
  });
  return tl;
}
function moveBoxes(selector, duration = 1) {
  const tl = gsap.timeline();
  tl.to(selector, {
    duration,
    y: 0,
    stagger: 0.6,
  });
  return tl;
}

function portalAnimation(selector, duration = 0.3, scaleX = 1.5, scaleY = 1) {
  const tl = gsap.timeline();
  tl.to(selector, { scaleX, scaleY, duration });
  return tl;
}

function jumpAnimation(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { y: 8, duration: 0.2, yoyo: true, repeat: 1 });
  return tl;
}

function hideContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 0, opacity: 0, yPercent: -50, duration: 0.5 });
  return tl;
}

function showContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, y: 0, duration: 0.5 });
  return tl;
}

function gradientAnimation(selector, offset) {
  const tl = gsap.timeline();
  tl.to(selector, {
    attr: {
      offset: offset,
    },
    yoyo: true,
    repeat: 1,
    duration: 1.3,
  });
  return tl;
}
function setGradient(selector, stopOpacity, duration) {
  const tl = gsap.timeline();
  tl.to(selector, { stopOpacity, duration });
  return tl;
}
